import fox from './fox';
import fanatics from './fanatics';
import theSportingNews from './the-sporting-news';
import joe from './joe';

const themes = {
  fox,
  fanatics,
  'the-sporting-news': theSportingNews,
  joe
};

export default function (theme) {
  return themes[theme] ?? '';
}
